import { useCallback, useState, useRef } from "react";
import firebase from "firebase";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

var firebaseConfig = {
  apiKey: "AIzaSyBowtiJMLYjLu_JRinlk5ouxjYUao1h-pY",
  authDomain: "portfolio-lub2code.firebaseapp.com",
  projectId: "portfolio-lub2code",
  storageBucket: "portfolio-lub2code.appspot.com",
  messagingSenderId: "341609749274",
  appId: "1:341609749274:web:8a7a95137d9344a0692aa3",
  measurementId: "G-ZM55WCE8T0",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
var db = firebase.firestore();

function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

const Contact = ({ contactInfo }) => {
  const { location, phoneNumber, email } = contactInfo;

  const [name, setName] = useState("");
  const [eml, setEml] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [nameErr, setNameErr] = useState(false);
  const [emlErr, setEmlErr] = useState(false);
  const [messageErr, setMessageErr] = useState(false);

  const [alertMessage, setAlert] = useState(false);

  const contactForm = useRef(null);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setAlert(null);
  };

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      let error = false;
      if (!name) {
        setNameErr(true);
        error = true;
      }
      if (!eml || (eml && !validateEmail(eml))) {
        setEmlErr(true);
        error = true;
      }
      if (!message) {
        setMessageErr(true);
        error = true;
      }
      if (error) {
        return;
      }
      let today = new Date();

      db.collection("messages")
        .doc(today.toString())
        .set({
          name,
          eml,
          subject,
          message,
        })
        .then(() => {
          // setName("");
          // setEml("");
          // setSubject("");
          // setMessage("");
          window.location.reload(true);
          // setAlert("Thanks for contacting me. Will reply asap.");
        })
        .catch((error) => {
          setAlert(
            "Unfortunately you cannot contact me here. Please send an email using the contact information"
          );
        });

      console.log(contactForm.current);
    },
    [name, eml, subject, message]
  );
  return (
    <section id="contact" className="contact section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="section-title-2">
              <div className="line"></div>
              <div className="text">
                <p>Get In Touch</p>
                <h3>Contact Me</h3>
              </div>
            </div>
          </div>

          <div className="col-md-12">
            <div className="part-info">
              <div className="row">
                <div className="col-md-4 xs-mb-30">
                  <div className="info-block text-center">
                    <div className="icon">
                      <i className="jam jam-directions"></i>
                    </div>
                    <h5>My Location:</h5>
                    <p>{location}</p>
                  </div>
                </div>

                <div className="col-md-4 xs-mb-30">
                  <div className="info-block text-center">
                    <div className="icon">
                      <i className="jam jam-phone"></i>
                    </div>
                    <h5>Phone Number:</h5>
                    <p>{phoneNumber}</p>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="info-block text-center">
                    <div className="icon">
                      <i className="jam jam-envelope"></i>
                    </div>
                    <h5>Email Address:</h5>
                    <p>
                      <a href={"mailto:" + email}>{email}</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-12">
            <div className="contact-form">
              <form
                className="form"
                id="contact-form"
                action="contact.php"
                data-toggle="validator"
                ref={contactForm}
              >
                <div className="messages"></div>
                <div className="controls">
                  <div className="row">
                    <div className="col-md-6">
                      <div className={"form-group"}>
                        <input
                          id="form_name"
                          type="text"
                          name="name"
                          placeholder="Name *"
                          required="required"
                          onInput={({ target }) => {
                            setName(target.value);
                            setNameErr(false);
                          }}
                          value={name}
                        />
                        {nameErr && (
                          <div className="with-errors">name is required.</div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          id="form_email"
                          type="email"
                          name="email"
                          placeholder="Email *"
                          required="required"
                          onInput={({ target }) => {
                            setEml(target.value);
                            setEmlErr(false);
                          }}
                          value={eml}
                        />
                        {emlErr && (
                          <div className="with-errors">
                            Valid email is required.
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="form-group">
                        <input
                          id="form_subject"
                          type="text"
                          name="subject"
                          placeholder="subject"
                          onInput={({ target }) => {
                            setSubject(target.value);
                          }}
                          value={subject}
                        />
                      </div>
                    </div>

                    <div className="col-md-12 form-group">
                      <textarea
                        id="form_message"
                        name="message"
                        className="form_message"
                        placeholder=" Type Your Message "
                        required="required"
                        onInput={({ target }) => {
                          setMessage(target.value);
                          setMessageErr(false);
                        }}
                        value={message}
                      ></textarea>
                      {messageErr && (
                        <div className="with-errors">
                          Please, leave us a message.
                        </div>
                      )}
                    </div>

                    <div className="col-md-12">
                      <button className="btn" onClick={onSubmit}>
                        <span>Send Message</span>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={alertMessage}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity="success">
          {alertMessage}
        </Alert>
      </Snackbar>
    </section>
  );
};

export default Contact;
